<template>
  <span class="scaling-svg-container">
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" class="scaling-svg">
      <g transform="translate(-174 -353)">
        <g transform="translate(172 351)">
          <g transform="translate(1.75 1.75)">
            <path d="M0,.583a.583.583,0,1,1,.583.583A.583.583,0,0,1,0,.583Z" transform="translate(2.333 3.5)" />
            <path d="M0,.583a.583.583,0,1,1,.583.583A.583.583,0,0,1,0,.583Z" transform="translate(2.333 5.833)" />
            <path d="M.583,0a.583.583,0,1,0,.583.583A.583.583,0,0,0,.583,0Z" transform="translate(4.667 3.5)" />
            <path d="M0,.583a.583.583,0,1,1,.583.583A.583.583,0,0,1,0,.583Z" transform="translate(7 3.5)" />
            <path
              d="M9.778,11H1.222A1.223,1.223,0,0,1,0,9.778V2.444A1.223,1.223,0,0,1,1.222,1.222H2.444V.611a.611.611,0,0,1,1.223,0v.611H7.333V.611a.611.611,0,0,1,1.223,0v.611H9.778A1.223,1.223,0,0,1,11,2.444V9.778A1.223,1.223,0,0,1,9.778,11ZM1.833,2.444a.612.612,0,0,0-.611.612V9.167a.612.612,0,0,0,.611.611H9.167a.612.612,0,0,0,.611-.611V3.056a.612.612,0,0,0-.611-.612Z"
              transform="translate(0.25 0.25)"
            />
          </g>
        </g>
        <rect width="5" height="5" transform="translate(179 358)" fill="#fff" />
        <rect width="9" height="8" transform="translate(179 358)" fill="#fff" />
        <g transform="translate(176 354)">
          <g transform="translate(1.75 1.75)">
            <path d="M0,.583a.583.583,0,1,1,.583.583A.583.583,0,0,1,0,.583Z" transform="translate(2.333 3.5)" />
            <path d="M0,.583a.583.583,0,1,1,.583.583A.583.583,0,0,1,0,.583Z" transform="translate(2.333 5.833)" />
            <path d="M.583,0a.583.583,0,1,0,.583.583A.583.583,0,0,0,.583,0Z" transform="translate(4.667 3.5)" />
            <path d="M0,.583a.583.583,0,1,1,.583.583A.583.583,0,0,1,0,.583Z" transform="translate(7 3.5)" />
            <path
              d="M9.778,11H1.222A1.223,1.223,0,0,1,0,9.778V2.444A1.223,1.223,0,0,1,1.222,1.222H2.444V.611a.611.611,0,0,1,1.223,0v.611H7.333V.611a.611.611,0,0,1,1.223,0v.611H9.778A1.223,1.223,0,0,1,11,2.444V9.778A1.223,1.223,0,0,1,9.778,11ZM1.833,2.444a.612.612,0,0,0-.611.612V9.167a.612.612,0,0,0,.611.611H9.167a.612.612,0,0,0,.611-.611V3.056a.612.612,0,0,0-.611-.612Z"
              transform="translate(0.25 0.25)"
            />
          </g>
        </g>
      </g>
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class DuplicateBookingIcon extends Vue {}
</script>

<style></style>
